import { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import VirtualizedAutocomplete from "../../../virtualization/virtualizedAutocomplete";
import { getHostsDoCliente } from "../api";

// Seletor reutilizável: escolhe um cliente e, opcionalmente, um host desse
// cliente. Carrega os hosts do cliente via /interno/findMany/hostsCliente e
// resolve o nome de cada host contra `allHosts` (do /zabbix/hostList), no
// mesmo padrão de createUpdateAgendamentoInterno/HostsAndSettings.
export default function SeletorClienteHost({
	clientes = [],
	allHosts = [],
	clienteId,
	onClienteChange,
	hostId,
	onHostChange,
	exigirHost = false,
	desabilitado = false,
}) {
	const [hostsCliente, setHostsCliente] = useState([]);
	const [carregandoHosts, setCarregandoHosts] = useState(false);

	const labelCliente = (c) =>
		c
			? `${c?.clienteErpId ? c.clienteErpId + " - " : ""}${c?.nome || c?.id}`
			: "";

	// /zabbix/hostList devolve { hostid, host, groups } — NÃO tem `name`.
	const nomeHost = (id) => {
		const h = allHosts.find((x) => String(x?.hostid) === String(id));
		return h?.host || h?.name || id;
	};

	useEffect(() => {
		let ativo = true;
		if (!clienteId) {
			setHostsCliente([]);
			return;
		}
		(async () => {
			try {
				setCarregandoHosts(true);
				const dados = await getHostsDoCliente(clienteId);
				if (!ativo) return;
				// dedup por hostId (um cliente pode ter vários serviços no mesmo host)
				const ids = [
					...new Set(
						(dados || []).map((d) => d?.hostId).filter(Boolean).map(String)
					),
				];
				setHostsCliente(ids);
			} catch (_) {
				if (ativo) setHostsCliente([]);
			} finally {
				if (ativo) setCarregandoHosts(false);
			}
		})();
		return () => {
			ativo = false;
		};
	}, [clienteId]);

	const clienteSelecionado =
		clientes.find((c) => c?.id === clienteId) || null;

	return (
		<>
			<VirtualizedAutocomplete
				options={clientes}
				value={clienteSelecionado}
				disabled={desabilitado}
				getOptionLabel={labelCliente}
				isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
				onChange={(_, cliente) => {
					onClienteChange(cliente?.id || null);
					onHostChange && onHostChange(null);
				}}
				renderInput={(params) => (
					<TextField {...params} label="Cliente" size="small" />
				)}
			/>

			{exigirHost && (
				<Autocomplete
					sx={{ mt: 2 }}
					options={hostsCliente}
					value={hostId || null}
					disabled={desabilitado || !clienteId}
					loading={carregandoHosts}
					getOptionLabel={(id) => nomeHost(id)}
					isOptionEqualToValue={(opt, val) => String(opt) === String(val)}
					onChange={(_, id) => onHostChange(id || null)}
					noOptionsText={
						clienteId ? "Cliente sem hosts" : "Selecione um cliente"
					}
					renderInput={(params) => (
						<TextField
							{...params}
							label="Host (equipamento)"
							size="small"
							helperText={
								clienteId
									? "Hosts monitorados deste cliente"
									: "Escolha um cliente primeiro"
							}
						/>
					)}
				/>
			)}
		</>
	);
}
